import ServiceInterceptor from '../../../services/ServiceInterceptor';

export const getRebateReceiptsList = (memberId, quarter, year) => ServiceInterceptor.get(`/members/${memberId}/rebate-funds-overview-detail?quarter=${quarter}&year=${year}`);
